import { Timeline, TimelineConnector, TimelineContent, TimelineDot, TimelineItem, TimelineOppositeContent, TimelineSeparator, timelineItemClasses, timelineOppositeContentClasses } from "@mui/lab";
import { IWarrantyHistory } from "../../../models/WarrantyManagement"
import { Grid, Typography } from "@mui/material";
import { getAddressObject } from "../../../helpers/utils/getAddressObject";
import { AddressLabel } from "../../../components/label/AddressLabel";
import { format } from "date-fns";

type IProps = {
    list: Array<IWarrantyHistory>;
}

const WarrantyTimeline = (props: IProps) => {

    const getAddress = (record: IWarrantyHistory) => {

        return getAddressObject(
        record?.streetAddress1,
        record?.streetAddress2,
        record?.city,
        record?.state,
        record?.country,
        record?.postalCode
        )
    }

    const isExpired = (record: IWarrantyHistory) => {

        var isExpired = record?.expirationDate && new Date(record.expirationDate) < new Date();
        
        //only check if first expirationDate is expired.
        if(isExpired && record?.expirationDate2 && new Date(record.expirationDate2) < new Date()) {
            isExpired = true;
        }

        return isExpired;
    }

    const getExpirationDateLabel = (warrantyType: string, index: number) => {
        if(warrantyType === "consumer" && index === 0) {
            return "5 Yr Expiration Dt";
        }

        if(warrantyType === "international") {
            return "1 Yr Expiration Dt";
        }

        return "Expiration Date";
    }

    const getExpirationDate2Label = (warrantyType: string, index: number) => {
        if(index === 0 || warrantyType === "international") {
            return "10 Yr Expiration Dt";
        }

        return "Expiration Date";
    }

    return (
        <Timeline sx={{[`& .${timelineItemClasses.root}:before`]: {flex: 0, padding: 0, }}}>
        {props.list.map((record, index) => (
            <TimelineItem key={index}>
                <TimelineSeparator>
                    <TimelineDot color={index > 0 || isExpired(record) ? "error" : "primary"} />
                    <TimelineConnector/>
                </TimelineSeparator>
                <TimelineContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6} md={6} lg={6}>
                            <Typography variant="subtitle2" className="bold-label" component="span" sx={{paddingRight: "5px"}} >
                                {`${record?.firstName} ${record?.lastName}`}
                            </Typography>
                            <Typography variant="subtitle2">
                                {record?.email}  
                            </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={6} sx={{textAlign: {xs: 'left', lg: 'right'}}}>
                            <AddressLabel variant="subtitle2" address={getAddress(record)} />
                        </Grid>
                        <Grid item xs={12}>

                            <Grid container spacing={2}>
                                <Grid item xs={6}>
                                    <Typography variant="subtitle2" className={`warrantyDate ${ index > 0 || isExpired(record) ? 'red' : "" }`}>
                                        Effective Date
                                    </Typography>
                                    <Typography variant="subtitle2" className={`warrantyDate ${ index > 0 || isExpired(record) ? 'red' : "" }`}>
                                        {record?.effectiveDate &&
                                            format(new Date(record?.effectiveDate),"yyyy-MM-dd")
                                        }
                                    </Typography>
                                </Grid>
                                <Grid item xs={6} sx={{textAlign: {xs: 'left', lg: 'right'}}}>
                                    <Grid container spacing={2}>
                                    {(record?.warrantyType !== "consumerlimited") && (
                                        <Grid item xs={12}>
                                            <Typography variant="subtitle2" className={`warrantyDate ${
                                                record?.expirationDate && new Date(record.expirationDate) < new Date() ? 'red' : "" }`}
                                            >
                                                {getExpirationDateLabel(record?.warrantyType, index)}
                                            </Typography>
                                            <Typography variant="subtitle2" className={`warrantyDate ${
                                                record?.expirationDate && new Date(record.expirationDate) < new Date() ? 'red' : "" }`}
                                            >
                                                {record?.expirationDate &&
                                                    format(new Date(record?.expirationDate),"yyyy-MM-dd")
                                                }
                                            </Typography>
                                        </Grid>
                                    )}

                                    {((record?.warrantyType === "consumer" && index == 0) 
                                        || record?.warrantyType === "consumerlimited" 
                                        || record?.warrantyType === "international") && (
                                        <Grid item xs={12}>
                                            <Typography variant="subtitle2" className={`warrantyDate ${
                                                record?.expirationDate2 && new Date(record.expirationDate2) < new Date() ? 'red' : "" }`}
                                            >
                                                {getExpirationDate2Label(record?.warrantyType, index)}
                                            </Typography>
                                            <Typography variant="subtitle2" className={`warrantyDate ${
                                                record?.expirationDate2 && new Date(record.expirationDate2) < new Date() ? 'red' : "" }`}
                                            >
                                                {record?.expirationDate2 &&
                                                    format(new Date(record?.expirationDate2),"yyyy-MM-dd")
                                                }
                                            </Typography>
                                        </Grid>
                                    )}

                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>          
                </TimelineContent>
            </TimelineItem>
        ))}
        </Timeline>        
    );
}

export default WarrantyTimeline;